import type { BaseType } from 'antd/lib/typography/Base';
import type { JSX } from 'react';

import { SpecificationIntervalMultiselectField } from 'src/components/base/fields/SpecificationField/SpecificationIntervalField/SpecificationIntervalMultiselectField';
import { SpecificationIntervalSimpleField } from 'src/components/base/fields/SpecificationField/SpecificationIntervalField/SpecificationIntervalSimpleField';
import type { IProductSpecificationFieldReference } from 'src/types/reference/IProductSpecificationReference';

type SpecificationIntervalFieldProps = {
  commonFieldProps: {
    errorType: BaseType;
    name: string;
    label?: string;
    description?: string | null;
    disabled?: boolean;
  };
  field: IProductSpecificationFieldReference;

  containerClassName?: string;
  className?: string;
};

export function SpecificationIntervalField({
  commonFieldProps,
  field,
  containerClassName,
  className,
}: Readonly<SpecificationIntervalFieldProps>): JSX.Element {
  if (field.multiselect || field.showOptions) {
    return (
      <SpecificationIntervalMultiselectField
        name={commonFieldProps.name}
        specificationField={field}
        className={className}
        containerClassName={containerClassName}
        errorType={commonFieldProps.errorType}
        disabled={commonFieldProps.disabled}
      />
    );
  }

  return (
    <SpecificationIntervalSimpleField
      commonFieldProps={commonFieldProps}
      allowedMeasureUnits={field.allowedMeasureUnits}
      className={className}
      containerClassName={containerClassName}
    />
  );
}
